export default __webpack_public_path__ + "static/media/lp.c7fbf187.png";